<template>
  <v-card class="mt-0 flex d-flex flex-column" outlined :loading="loading">
    <v-card-title class="justify-center">
      Monthly Upgrade Fee MRR

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
        </template>
        <span>Total monthly value of all active Monthly Upgrade Fees</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap align-center fill-height>
        <v-flex>
          <!-- SUBSCRIPTION MMR TOTAL -->
          <span class="mmr">{{ subscriptionTotal | dollarsCents }}</span>
          <p class="other-stats">
            <!-- PREMIUM PARTNERS -->
            Premium Providers: {{ numCurrentPartners }}
            <br />
            <!-- ACTIVE SUBSCRIPTIONS -->
            Listings with Active Monthly Upgrade Fees:
            {{ numActiveSubscriptions }}
          </p>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { getSubscriptionMMR } from "../../api/report";

export default {
  name: "SubscriptionsMMR",

  data() {
    return {
      loading: false,
      subscriptionTotal: 0,
      numCurrentPartners: 0,
      numActiveSubscriptions: 0
    };
  },

  mounted() {
    this.loadCurrentMMR();
  },

  methods: {
    async loadCurrentMMR() {
      try {
        this.loading = true;

        const result = await getSubscriptionMMR();
        this.numCurrentPartners = result.companiesActive;
        this.numActiveSubscriptions = result.subscriptionsActive;
        this.subscriptionTotal = result.subscriptionsRevenue;
      } catch (e) {
        console.error("ERROR GETTING CURRENT SUBSCRIPTION MMR", e);
      }

      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card__text {
  height: 100%;
  text-align: center;
  .mmr {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.87);
  }
  .mmr-icon {
    top: -5px;
  }
  .positive {
    color: green;
  }
  .negative {
    color: red;
  }
  .other-stats {
    i {
      font-size: 18px;
      top: -2px;
    }
  }
}
</style>
